import { render } from "./VerifyOtp.vue?vue&type=template&id=097bac80"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"

import "./VerifyOtp.vue?vue&type=style&index=0&id=097bac80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__